<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection v-if="form.statuses">
            <template #title>
                Submissions
            </template>

            <statuses :statuses="form.statuses" :assignment="form" :assignmentLabel="assignmentLabel" />
            
        </FormSection>
        
        <FormSection v-if="!assignment.id">
            <template #title>
                Details
            </template>

            <FormGroup
                name="title"
                label="Title">
                <Input
                    ref="title"
                    v-model="form.title"
                    name="title"
                    placeholder="Please enter the title..."/>
            </FormGroup>

            <FormGroup
                name="description"
                label="Description">
                <Textarea
                    v-model="form.description"
                    name="description"
                    rows="6"
                    placeholder="Please enter the description..."/>
            </FormGroup>

            <FormGroup
                name="course_id"
                label="Course">
                <Select
                    v-model="form.course_id"
                    name="pathway_id"
                    :options="courses"
                    placeholder="Please select a course..."/>
            </FormGroup>
        </FormSection>

        <FormSection>
            <template #title>
                {{ assignmentLabel }}
            </template>

            <div v-if="form.new_status">
                <FormGroup
                    name="new_status.upload"
                    label="Upload">
                    <File
                        v-model="form.new_status.upload"
                        :file="form.new_status.upload"
                        :image="false"
                        accept=""/>
                </FormGroup>

                <FormGroup
                    name="new_status.description"
                    label="Notes">
                    <Textarea
                        v-model="form.new_status.description"
                        name="description"
                        rows="3"
                        placeholder="Enter any notes..."/>
                </FormGroup>
            </div>            

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>

    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";
import Select from "@/Components/Form/Select.vue";
import File from "@/Components/Form/File.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Label from "@/Components/Form/Label.vue";
import Checkbox from "@/Components/Form/Checkbox.vue";
import Statuses from "@/Pages/Student/Assignment/Components/Statuses";
import {optionsToArray} from "@/Lib/Helpers";
import axios from "axios";

export default {

    name: "AssignmentForm",

    props: {
        assignment: {
            type: Object,
            default: () => ({})
        },
        assignmentLabel: {
            type: String,
            default: () => 'Assignment'
        },
        assignmentType: {
            type: Number,
            default: () => 1
        }
    },

    emits: ['submit'],

    data() {
        return {
            loaded: false,
            courses: [],
        };
    },

    inject: ['form'],

    async created() {
        await Promise.all([
            this.fetchCourses(),
        ])

        this.loaded = true;
    },

    components: {
        FormSection,
        FormGroup,
        Input,
        Select,
        File,
        Textarea,
        Label,
        InputError,
        Checkbox,
        Statuses
    },

    methods: {
        async fetchCourses() {
            const courses = (await axios.get(route('api.student.courses'), {params: {courseType:this.assignmentType}})).data.data;
            this.courses = courses.map(row => {
                return {
                    value: row.id,
                    label: row.title
                }
            });
        },
    },

    watch: {
        
    }
};

</script>
